import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
export class TdAlertDialogComponent {
  title: string;
  message: string;
  closeButton: string = 'CLOSE';
/**
 * @param {?} _dialogRef
 */
constructor(private _dialogRef: MdDialogRef<TdAlertDialogComponent>) {}
/**
 * @return {?}
 */
close(): void {
    this._dialogRef.close();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css' ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
}

function TdAlertDialogComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdAlertDialogComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdAlertDialogComponent.ctorParameters;
/** @type {?} */
TdAlertDialogComponent.prototype.title;
/** @type {?} */
TdAlertDialogComponent.prototype.message;
/** @type {?} */
TdAlertDialogComponent.prototype.closeButton;
/** @type {?} */
TdAlertDialogComponent.prototype._dialogRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
